import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CloseMobileNavMenu, SetDisplaySidenav } from '@app/app/app-frame/store/app-frame.actions';
import { AppFrameState } from '@app/app/app-frame/store/app-frame.state';
import { LucideChevronLeft, LucideChevronsLeft, LucideChevronsRight, LucideIconInput } from '@lucide/angular';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export interface SidebarBackLink {
  label: string;
  url: string;
}

@Component({
  selector: 'ptl-secondary-sidebar',
  templateUrl: './secondary-sidebar.component.html',
  styleUrls: ['./secondary-sidebar.component.scss'],
})
export class SecondarySidebarComponent implements OnInit, OnDestroy {
  @Input() type = '';
  @Input() title = '';
  @Input() icon: LucideIconInput;
  @Input() isCollapsed = false;
  @Input() rightSidebar: boolean;
  @Input() backLink: SidebarBackLink | null = null;
  @Input() alwaysVisibleOnMobile = false;

  @Select(AppFrameState.isMobileMenuExpanded)
  mobileMenuExpanded$: Observable<boolean>;

  protected readonly LucideChevronLeft = LucideChevronLeft;
  protected readonly LucideChevronsLeft = LucideChevronsLeft;
  protected readonly LucideChevronsRight = LucideChevronsRight;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.store.dispatch(new SetDisplaySidenav(false));
  }

  ngOnDestroy(): void {
    this.store.dispatch(new SetDisplaySidenav(true));
  }

  onToggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
  }

  closeMobileMenu(): void {
    this.store.dispatch(new CloseMobileNavMenu());
  }
}
